import { useT } from '../lib/i18n';
import React from 'react';
import type { JourneyStatus, SessionStatus } from '@/services/learningService';

type AnyStatus = JourneyStatus | SessionStatus;

const CLS: Record<AnyStatus, string> = {
  completed: 'bg-success-soft text-success-strong',
  in_progress: 'bg-blue-100 text-blue-700 dark:bg-blue-500/[0.16] dark:text-blue-300',
  upcoming: 'bg-orange-100 text-orange-700 dark:bg-orange-500/[0.16] dark:text-orange-300',
  scheduled: 'bg-orange-100 text-orange-700 dark:bg-orange-500/[0.16] dark:text-orange-300',
  attended: 'bg-teal-100 text-teal-700 dark:bg-teal-500/[0.16] dark:text-teal-300',
  missed: 'bg-red-100 text-red-700 dark:bg-red-500/[0.16] dark:text-red-300',
  past: 'bg-muted text-muted-foreground',
  cancelled: 'bg-muted text-muted-foreground line-through',
  draft: 'bg-muted text-muted-foreground',
};

/** Journey status (viewer-relative) or session lifecycle status chip. */
export const SessionStatusChip: React.FC<{ status: AnyStatus | string; className?: string }> = ({ status, className }) => {
  const t = useT();
  const labels: Record<string, string> = {
    completed: t('training:status_completed', 'Completed'),
    in_progress: t('training:status_in_progress', 'In progress'),
    upcoming: t('training:status_upcoming', 'Upcoming'),
    scheduled: t('training:status_scheduled', 'Scheduled'),
    attended: t('training:status_attended', 'Attended · to complete'),
    missed: t('training:status_missed', 'Missed'),
    past: t('training:status_past', 'Past'),
    cancelled: t('training:status_cancelled', 'Cancelled'),
    draft: t('training:status_draft', 'Draft'),
  };
  return (
    <span data-testid="session-status-chip" data-status={status}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${CLS[status as AnyStatus] || 'bg-muted text-muted-foreground'} ${className || ''}`}>
      {labels[status] || String(status).replace('_', ' ')}
    </span>
  );
};

export default SessionStatusChip;
